/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './qualification-drawer.stache';
import can from 'can';
import _ from 'lodash';

const playerPageUrl = window.globalSettings.pagePaths.player;

Component.extend({
    tag: 'qualification-drawer',
    template: template,
    viewModel: {
        define: {
            playerPagePath: {
                get() {
                    let playerId = this.attr('identifier');
                    return can.sub(playerPageUrl, { playerId });
                },
            },
            courseLocation: {
                get() {
                    const courseCity = this.attr('courseCity') || '';
                    const courseState = this.attr('courseState') || '';
                    const location = this.attr('location');

                    if (location) {
                        return location;
                    }

                    return courseCity && courseState
                        ? `${courseCity}, ${courseState}`
                        : `${courseCity} ${courseState}`;
                },
            },
        },
    },
    events: {
        inserted() {
            this.viewModel.attr('exemptionsLeft', []);
            this.viewModel.attr('exemptionsRight', []);

            let exemptions = _.sortBy(
                this.viewModel.attr('exemptions'),
                function(item) {
                    return item.exemptionNumber;
                },
            );
            let exemptionsCount = exemptions.length;

            this.viewModel.attr('exemptions', exemptions);

            if (exemptionsCount && exemptionsCount > 0) {
                let exemptionsMiddleIndex;

                if (exemptionsCount % 2 == 0) {
                    exemptionsMiddleIndex = exemptionsCount / 2;
                } else {
                    exemptionsMiddleIndex = Math.floor(exemptionsCount / 2) + 1;
                }

                this.viewModel.attr('exemptions').each((element, index) => {
                    if (index + 1 <= exemptionsMiddleIndex) {
                        this.viewModel.attr('exemptionsLeft').push(element);
                    } else {
                        this.viewModel.attr('exemptionsRight').push(element);
                    }
                });
            }
        },
    },
});
